


import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import Assets from '@/constants/assets';
import Btn, {
BtnWidth,
BtnHeight,
BtnColor
} from '@/shared/components/btn.component.vue';
import Input, {
InputType,
InputStyle,
InputAlign
} from '@/shared/components/input.component.vue';
import SpotlightText, {
SpotlightTextColor,
SpotlightTextBorderType
} from '@/shared/components/SpotlightText.component.vue';
import AppService, { Applications } from '@/core/services/app.service';
import UtilsService from '@/core/services/utils.service';

@Component({
components: {
  Btn,
  Input,
  Icon,
  SpotlightText
}
})
export default class MyIdLogin extends Vue {
private assets = Assets;
private applications = Applications;
private dni: string = '';
private password: string = '';
private inputType = InputType;
private inputAlign = InputAlign;
private inputStyle = InputStyle;
private btnColor = BtnColor;
private btnWidth = BtnWidth;
private btnHeight = BtnHeight;
private iconEnum = IconEnum;
private cardText= "Introduce aquí tu DNI para acceder a la configuración de las fechas y plazos del producto adquirido:";
private rememberAccess = false;
private spotlightTextColor = SpotlightTextColor;
private spotlightTextBorderType = SpotlightTextBorderType;
private showingError = false;
private app: string = AppService.current();
private showAppSelector: boolean = UtilsService.inDebug();
private loginDni = true;
private budgets = [];

get backgroundColor() {
  return {
    'background-color': 'black',
  };
}

get whatsappLogoStyles() {
  return {
    'width': '30px',
  };
}

get logoImage() {
  let brand = this.assets.logoTlpe;
  return brand
}

get whatsappImage() {
  let brand = this.assets.whatsappImg;
  return brand
}

private created() {
  this.dni = this.$route.params.dni;
  if (this.dni) {
    this.fetchAcceptanceBudgetList();
  }
}

private fetchAcceptanceBudgetList() {
  this.showingError = false;
  this.$store
    .dispatch('fetchAcceptanceBudgetList', { dni: this.dni })
    .then((res) => {
      this.budgets = res;
      this.loginDni = false;
      this.cardText = 'Por favor seleccione el alta de aceptación que desea configurar: '
      // this.fetchProfile();
      // this.$router.push('/');
    })
    .catch((err) => {
      this.showingError = true;
      setTimeout(() => {
        this.showingError = false;
      }, 1000);
      
    });
}

private routeBudget(pk:any) {
  return pk + '/acceptance/1';
}

private fetchProfile() {
  this.$store.dispatch('fetchProfile');
}

private handleKey(e: any) {
  if (e.keyCode === 13) {
    // this.login();
  }
}

private sendHelp() {
  // window.location.href = "https://api.whatsapp.com/send/?phone=635251478&text=ayuda+acceso+presupuestos&app_absent=1";
  window.location.href = "https://wa.link/d695lj";
  this.showingError = false;
}

private goBudget(budget:any) {
  window.open(
      (process.env.NODE_ENV == 'development' ? 'http://' : 'https://') + process.env.VUE_APP_MANAGER_DOMAIN + "/#/client/budget/" + budget + "/acceptance/1",
      '_blank' // <- This is what makes it open in a new window.
    );
}

private changeApp(app: string): void {
  AppService.changeApp(app);
}
}
